import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'María',
  city: 'CABA'
}, {
  name: 'Laura',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Ana',
  city: 'Mendoza'
}, {
  name: 'Florencia',
  city: 'La Plata'
}, {
  name: 'Lucía',
  city: 'Mar del Plata'
}, {
  name: 'Carolina',
  city: 'Tucumán'
}, {
  name: 'Julieta',
  city: 'Salta'
}, {
  name: 'Martina',
  city: 'Neuquén'
}, {
  name: 'Paula',
  city: 'Santa Fe'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const interval = setInterval(() => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 3000); // Hide after 3 seconds
    }, 8000); // Show every 8 seconds to give it a 5 second gap
    return () => clearInterval(interval);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-146">
      <div className="bg-white rounded-lg shadow-lg p-3 pr-6 flex items-center gap-3 border border-sage" data-id="element-147">
        <div className="bg-sage p-2 rounded-full text-green-700" data-id="element-148">
          <ShoppingBag size={18} data-id="element-149" />
        </div>
        <div data-id="element-150">
          <p className="text-sm font-bold text-brown-800" data-id="element-151">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-brown-600" data-id="element-152">
            acaba de comprar Freezer Inteligente
          </p>
        </div>
      </div>
    </div>;
}